//The pre-loaded templates contain all the angular template html files in one javascript file
if (!process.env.IS_WEBPACK_DEV) {
  require("./../js/pcmwebui_template_cache.js");
} else {
  //Don't load if running npm start, to streamline development
  angular.module("templates-pcmWebUI", []);
}

const config = require("config");
const eventTracker = require("./alk-engagement/eventTracker");
eventTracker.init(config, require("appboy-web-sdk"));

(function () {
  var id = "app";
  var app = angular.module(id, [
    // Angular modules
    "ngAnimate", // animations
    "ngRoute", // routing
    "ui.sortable",
    "ui.bootstrap",
    "ui.bootstrap.showErrors",
    "pcmCommon",
    "alk.authentication",
    "alk.accountManagement",
    "ui.utils",
    "uiSwitch",
    "templates-pcmWebUI", // pre-loaded templates
    "alk.services",
    "pcmwsui.message",
    "alk.maps",
    "alk.modal",
    "alk.import",
    "alk.cloud",
    "pascalprecht.translate",
    "alk.constants",
    "ngSanitize",
    "ngCookies",
    "alk.fleetportal",
    "alk.places",
    "alk.routeExceptions",
    "alk.filters",
    "alk.singlesearch",
    "alk.marketing",
    "alk.forms",
    "alk.directives",
    "alk.translations",
    "tmh.dynamicLocale",
    "visibilityChange"
    // Custom modules

    // 3rd Party Modules
  ]);

  app.constant("alkapplication", "pcmilerweb");
  app.constant("_", require("lodash"));
  app.constant("ALKMaps", window.ALKMaps);
  app.constant("papaparse", require("papaparse"));
  app.constant("eventTracker", eventTracker);

  // Routes
  app.config(["$routeProvider", "$locationProvider", function ($routeProvider, $locationProvider) {
    $locationProvider.html5Mode(true);

    $routeProvider._when = $routeProvider.when;
    $routeProvider.when = function (path, route) {
      route.resolve = angular.merge(route.resolve || {}, {
        fingerprinted: ["$rootScope", "$q", function ($rootScope, $q) {
          var authenticationPromise = $q.defer();
          if ($rootScope.preloginFinished === true) {
            authenticationPromise.resolve();
            return authenticationPromise.promise;
          }

          $rootScope.$watch(() => $rootScope.preloginFinished, () => {
            if ($rootScope.preloginFinished === true) {
              authenticationPromise.resolve();
            }
          });

          return authenticationPromise.promise;
        }]
      });

      return $routeProvider._when(path, route);
    };

    $routeProvider.
      when("/", {
        templateUrl: "/pages/landingPage.html",
        requireLogin: false,
        bodyClass: "unrestricted homePage",
        title: "Home"
      }).
      when("/features", {
        templateUrl: "/pages/featuresPage.html",
        requireLogin: false,
        bodyClass: "unrestricted featuresPage contentPage",
        title: "Features"
      }).
      when("/info", {
        redirectTo: "/features"
      }).
      when("/contact", {
        redirectTo: "/"
      }).
      when("/contact/success", {
        redirectTo: "/"
      }).
      when("/contact/error", {
        redirectTo: "/"
      }).
      when("/login", {
        redirectTo: "/"
      }).
      when("/signupLogin", {
        redirectTo: "/"
      }).
      when("/signup", {
        templateUrl: "/pages/signUpPage.html",
        requireLogin: false,
        bodyClass: "unrestricted signUpPage contentPage",
        title: "Sign Up"
      }).
      when("/app", {
        templateUrl: "/pages/mainPage.html",
        requireLogin: true,
        bodyClass: "mainPage",
        title: "Route Planning and Reporting",
        reloadOnSearch: false,
        resolve: {
          // the app needs the default options for any routes that it creates so ensure that it is loaded.  This prevents having to restructure a lot to use promises everywhere.
          "defaultOptions": ["$rootScope", "$q", "routingProfile", function ($rootScope, $q, routingProfile) {
            var deferred = $q.defer();

            $rootScope.$watch(() => $rootScope.preloginFinished, () => {
              if ($rootScope.preloginFinished === true) {
                deferred.resolve();
              }
            });
            return deferred.promise.then(() => routingProfile.getDefaultOptionsPromise());
          }],
          "placeSets": ["$rootScope", "$q", "userService", function ($rootScope, $q, userService) {
            //jira: SWPWEB-974
            return []// userService.getPlacesDataPromise();
          }]
        }
      }).
      when("/account", {
        templateUrl: "/pages/accountPage.html",
        requireLogin: true,
        expiredUserAllowed: true,
        bodyClass: "accountPage withHeader",
        title: "My Account"
      }).
      when("/applicationSettings", {
        templateUrl: "/app/applicationSettings/applicationSettings.html",
        requireLogin: true,
        bodyClass: "applicationSetting withHeader",
        title: "Application Settings",
        resolve: {
          // the app needs the default options for any routes that it creates so ensure that it is loaded.  This prevents having to restructure a lot to use promises everywhere.
          "defaultOptions": ["$rootScope", "$q", "routingProfile", function ($rootScope, $q, routingProfile) {
            var deferred = $q.defer();

            $rootScope.$watch(() => $rootScope.preloginFinished, () => {
              if ($rootScope.preloginFinished === true) {
                deferred.resolve();
              }
            });
            return deferred.promise.then(() => routingProfile.getDefaultOptionsPromise());
          }]
        }
      }).
      when("/help", {
        templateUrl: "/pages/helpPage.html",
        requireLogin: true,
        expiredUserAllowed: true,
        bodyClass: "helpPage withHeader",
        title: "Help"
      }).
      when("/resetPassword", {
        templateUrl: "/pages/resetPassword.html",
        requireLogin: false,
        bodyClass: "unrestricted loginPage contentPage",
        title: "Reset Password"
      }).
      when("/acceptterms", {
        templateUrl: "/pages/acceptterms.html",
        requireLogin: true,
        expiredUserAllowed: true,
        bodyClass: "unrestricted loginPage contentPage",
        title: "Terms of Use"
      }).
      when("/terms", {
        templateUrl: "/pages/terms.html",
        requireLogin: false,
        expiredUserAllowed: true,
        bodyClass: "unrestricted contentPage",
        title: "Terms of Use"
      }).
      when("/tid/redirect", {
        templateUrl: "/pages/landingPage.html",
        requireLogin: false,
        expiredUserAllowed: true,
        bodyClass: "unrestricted contentPage",
        title: "redirect"
      }).
      when("/tid/logout", {
        templateUrl: "/pages/logout.html",
        requireLogin: false,
        expiredUserAllowed: true,
        bodyClass: "unrestricted contentPage",
        title: "logout"
      }).
      otherwise({
        redirectTo: "/"
      });
  }]);

  app.config(["alkAuthenticationServiceProvider", "alk.authentication.config", "moment", function (alkAuthenticationServiceProvider, authConfig, moment) {

    //Setup track.js
    if (config.trackJsEnvironment && typeof trackJs !== "undefined") {
      //console.log("Setting up trackjs for application \"" + config.trackJsEnvironment + "\"");
      trackJs.configure({
        application: config.trackJsEnvironment
      });
    }

    // set up authorization provider
    alkAuthenticationServiceProvider.dataAnywhereUrl = config.daUrl;
    alkAuthenticationServiceProvider.pcmilerUrl = config.pcmwsUrl;
    authConfig.ssoUrl = config.ssoUrl;
    authConfig.applicationName = config.applicationName;
    authConfig.pcmwsUrl = config.pcmwsUrl;
    authConfig.alkmapsApiKey = config.alkmapsApiKey;
    authConfig.reportApiKey = config.reportApiKey;
    authConfig.linkMappingUrl = config.linkMappingUrl;
    authConfig.clientId = config.clientId;
    authConfig.tidApplicationName = config.tidApplicationName;
    authConfig.trimbleCloudUrl = config.trimbleCloudUrl;
    authConfig.skipLogoutOnForbidden = true;

    alkAuthenticationServiceProvider.shouldLogoutOnForbidden = function (rejection) {
      if (rejection.config.url.indexOf("/v1/authenticate") >= 0) {
        return false;
      }

      if (rejection.config.url.indexOf("/api/Migrate/") === 0) {
        return false;
      }

      return true;
    };

    alkAuthenticationServiceProvider.extraUserProperties = {
      isTrialValid: function () {
        if (this.accountType !== "Trial") {
          return true;
        }

        if (this.remainingRoutes <= 0) {
          return false;
        }

        if (this.expired === true) {
          return false;
        }

        if (this.expirationDate != null && this.expirationDate < new Date()) {
          return false;
        }

        return true;
      },
      isAdmin: function () {
        var isAdmin = (this.roles != null && this.roles.indexOf("Company Administrator") !== -1) ? true : false;

        return isAdmin;
      },
      isPremium: function () {
        return this.subscriptionLevel === "Premium" || this.subscriptionLevel === "Trial";
      },
      getCreditExpiresDate: function () {
        return moment.utc(this.creditExpiredDate).endOf("day");
      },
      creditExpiresSoon: function () {
        if (!this.getCreditExpiresDate().isValid()) {
          return false;
        }

        var warnAt = this.getCreditExpiresDate().subtract(config.creditExpireWarningDays, "days");

        var now = moment().utc().startOf("day");

        return now.isAfter(warnAt);
      },
      checkCreditExpiration: function () {
        if (!this.getCreditExpiresDate().isValid()) {
          return false;
        }

        var now = moment().utc().startOf("day");
        return now.isAfter(this.getCreditExpiresDate());
      },
      canUseTripDirect: function () {
        return this.isTripDirectEnabled && this.isPremium();
      }
    };
  }]);

  app.config(["alk.singlesearch.config", function (singleSearchConfig) {
    singleSearchConfig.url = config.singleSearchUrl;
    singleSearchConfig.authToken = config.singleSearchAuthToken;
  }]);

  app.config(["alk.fleetportal.config", function (fleetViewConfig) {
    fleetViewConfig.apiUrl = config.fleetLinkUrl;
  }]);

  app.factory("fcWidgetAsync", [
    "$window",
    "$q",
    function (
      $window,
      $q
    ) {
      const fcWidgetStub = {
        init: () => {},
        destroy: () => {},
        isOpen: () => {},
        isInitialized: () => {},
        user: {
          setProperties: () => {}
        },
        open: () => {},
        close: () => {}
      }

      function createFCWidgetAsync() {
        const deferred = $q.defer();
        const scriptElement = document.createElement("script");
        scriptElement.async = true;
        scriptElement.onload = () => {
          if ($window.fcWidget) {
            deferred.resolve($window.fcWidget);
          } else {
            deferred.reject(fcWidgetStub);
          }
        };
        scriptElement.onerror = () => {
          deferred.reject(fcWidgetStub);
        };
        scriptElement.src = config.chat.scriptUrl;
        document.body.appendChild(scriptElement);
        return deferred.promise;
      }

      return createFCWidgetAsync();
    }
  ]);

  // Execute bootstrapping code and any dependencies.
  app.run(["$rootScope",  "$http", "$location", "UserProvider", "$timeout", "$q", "alkAuthenticationService", "$window", "VisibilityChange", "fcWidgetAsync",
    function ($rootScope, $http ,$location, UserProvider, $timeout, $q, alkAuthenticationService, $window, VisibilityChange, fcWidgetAsync) {
      //  now the app is starting, let's see if we can log in via our cookie
      $rootScope.preloginFinished = false;
      let redirectLocation;
      if ($location.search().r) {
        redirectLocation = decodeURIComponent($location.search().r);
      } else {
        var path = $location.path();
        if (path === undefined || path === null || path === "/") {
          redirectLocation = "/app";
        } else {
          redirectLocation = path;
        }
        if ($location.search().center) {
          redirectLocation += `?center=${$location.search().center}`;
        }
      }

      let skipCookieLogin = false;
      if (redirectLocation === "/resetPassword" || redirectLocation === "/features" ||
        redirectLocation === "/signup" || redirectLocation === "/terms" || redirectLocation === "/tid/redirect" || redirectLocation ==="/tid/logout") {
        skipCookieLogin = true;
      }
      if (redirectLocation.indexOf("/promo") > -1) {
        skipCookieLogin = true;

        var authToken = redirectLocation.substring(7);

        if (authToken) {
          var userObj = {
            "promo":true,
            "isLoggedIn": true,
            "maxNumberOfUsers": 1,
            "accountType": "PCMWeb",
            "subscriptionLevel": "Premium",
            "dataset": "PCM_NA",
            "region": "NA",
            "remainingRoutes": -1,
            "isInvoiced": false,
            "creditExpiredDate": "9999-12-31T23:59:59.9999999",
            "isTripDirectEnabled": false,
            "netSuiteOnline": false,
            "isMonthlyPaidCustomer": false,
            "userName": "rmehra+ian@alk.com",
            "firstName": "Rishi",
            "lastName": "Mehra",
            "account": "Trimble MAPS Marketing Offers",
            "userId": config.promo.userId,
            "accountId": config.promo.accountId,
            "expired": false,
            "expirationDate": null,
            "isDisabled": false,
            "roles": [
              "Company Administrator"
            ],
            "hasBillingIssue": false,
            "authToken": authToken,
            "currentTermsOfUseAccepted": true,
            "memberSince": "0001-01-01T00:00:00"
          }
        }
        UserProvider.loadUser(userObj);
        $timeout($location.url("/app"), 1000);
      }

      if (!skipCookieLogin) {
        var authenticationPromise = $q.defer();
        alkAuthenticationService.verify()
          .then(() => {
            authenticationPromise.resolve();
        var user = UserProvider.getUser();
        const data = window.localStorage.getItem("user_authToken");
    if (user && user.authToken !== data) {
        const sumoLogicUrl = config.sumoUrl
       var logData = {
                Message:"User logged in Legacy PCMilerWeb Application",          
                Timestamp: new Date().toISOString(),
                UserName: user.userName ,
                AccountName: user.account
                     };
        $http.post(sumoLogicUrl, logData)
                 .then(function(response) {
                       console.warn('Log sent to Sumo Logic');
                 })
                 .catch(function(error) {
                   console.error('Failed to send log to Sumo Logic:', error);
                 });
       }
          }, (err) => {
            authenticationPromise.reject();
            window.location.href =  `${config.pcmModernSite}`
          });

        authenticationPromise.promise.then(() => {
          $rootScope.preloginFinished = true;
          $location.url(redirectLocation);
        }, () => {
         // $location.url("/");
          $rootScope.preloginFinished = true;
        });
      } else {
        $rootScope.preloginFinished = true;
      }

      $rootScope.$on("$routeChangeStart", (event, next) => {

        var requireLogin = next.$$route.requireLogin;
        if (requireLogin) {
          var user = UserProvider.getUser();

          if (user.isLoggedIn !== true) {
            event.preventDefault();
            var gotoLogin = function () {
              $location.url("/login?path=" + next.$$route.originalPath);
            };

            $timeout(gotoLogin);
          } else if (user.currentTermsOfUseAccepted !== true && next.$$route.originalPath.indexOf("/acceptterms") < 0) {
            event.preventDefault();
            // only enter this condition if we are not already trying to route to the terms of use.  Otherwise we end up in infinite loop.
            var gotoTerms = function () {
              $location.url("/acceptterms?path=" + next.$$route.originalPath);
            };

            $timeout(gotoTerms);
          } else if (user.isTrialValid() !== true && next.$$route.expiredUserAllowed !== true && next.$$route.originalPath.indexOf("/account") < 0) {
            event.preventDefault();
            var gotoAccount = function () {
              $location.url("/account");
            };

            $timeout(gotoAccount);
           
          }
          else if (!user.isMonthlyPaidCustomer && user.expired)
          { 
              $location.url("/login");
              $rootScope.showAccountExpired = true;
          }
          else if (user.isMonthlyPaidCustomer && user.checkCreditExpiration() && next.$$route.expiredUserAllowed !== true && next.$$route.originalPath.indexOf("/account") < 0 && !user.isInvoiced) {
            event.preventDefault();
            var gotoAccount = function () {
              $location.url("/account");
            };

            $timeout(gotoAccount);

            // without the $evalAsync it was changing the url, but the view did not update.  Found this solution at the angular bug here: https://github.com/angular/angular.js/issues/9607
          } else if (user.hasBillingIssue === true && next.$$route.originalPath.indexOf("/app") >= 0) {
            // only force redirect to the account page when we have a billing issue and we are attempting to access the application.
            event.preventDefault();
            var gotoAccount = function () {
              $location.url("/account");
            };
            $timeout(gotoAccount);
          } else {
            eventTracker.track(eventTracker.EVENTS.LOGIN, {
              user
            });
            if (config.chat && config.chat.enabled) {
              // only enable chat for whitelisted regions
              const regionWL = config.chat.regionWhitelist;
              if (Array.isArray(regionWL) &&
                regionWL.some(whitelistedRegion => user.region === whitelistedRegion)
              ) {
                fcWidgetAsync.then(fcWidget => {
                  fcWidget.init({
                    token: config.chat.fcToken,
                    host: "https://wchat.freshchat.com",
                    // required, supposedly
                    externalId: user.userName,
                    config: {
                      headerProperty: {
                        hideChatButton: true
                      }
                    }
                  });
                });
              }
            }
          }
        }
      });

      $rootScope.$on("$routeChangeSuccess", (event, current) => {
        $rootScope.bodyClass = current.$$route.bodyClass;
        $rootScope.title = current.$$route.title;
      });

      // SWCX-556 - Everytime user goes back to the app from other browser tab, check if it still has access to this app
      VisibilityChange.configure({
        broadcast: true
      });

      $rootScope.$on("pageBecameVisible", (event) => {
        if ($rootScope.userInfo) {
          alkAuthenticationService.verifyService().then(
            (data) => {}, // user is good, do nothing
            (err) => { // user can not access any more, redirect user to login.
              // UserProvider.clearUser();
              fcWidgetAsync.then(fcWidget => {
                fcWidget.destroy();
              });
              // $location.url("/");
            }
          );
        }
      });

    }
  ]);
})();


// WEBPACK FOOTER //
// ./app/app.js